import { render, staticRenderFns } from "./TpvLeftSideBar.vue?vue&type=template&id=9382d38e"
import script from "./TpvLeftSideBar.vue?vue&type=script&lang=js"
export * from "./TpvLeftSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports